










import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/MHeader.vue";
import ResendForm from "@/components/forms/ResendForm.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    ResendForm,
    Footer,
  },
})
export default class MPreRegisterResend extends Vue {}
